import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  Flex,
  Grid,
  Input,
  List,
  Menu,
  Popover,
  Row,
  Typography,
} from "antd";
import { Header } from "antd/es/layout/layout";
import "./headerComponent.scss";
import { Image } from "antd";
import logo from "assets/images/logo.png"; // Adjust the path accordingly
import helpline from "assets/images/helpline.svg";
import language from "assets/images/language.png";
import {
  CaretDownOutlined,
  CloseOutlined,
  DownOutlined,
  MenuOutlined,
  UserOutlined,
} from "@ant-design/icons";

function HeaderComponent() {
  const { Text } = Typography;
  const [, setSelectedLanguage] = useState("English"); // Default language

  const handleLanguageChange = (key: string) => {
    let language = "English"; // Default to English
    if (key === "2") {
      language = "Spanish";
    } else if (key === "3") {
      language = "French";
    }
    setSelectedLanguage(language); // Update the selected language
  };

  const helplineMenu = (
    <Menu
      items={[
        { key: "1", label: "Helpline 1" },
        { key: "2", label: "Helpline 2" },
        { key: "3", label: "Helpline 3" },
      ]}
      onClick={({ key }) => handleLanguageChange(key)} // Update language when item is clicked
    />
  );

  const screens = Grid.useBreakpoint();
  {
    {
      console.log(screens.xs ? "center" : "stretch");
    }
  }
  const [openRPoint, setOpenRPoint] = useState(false);
  const [openCreditLimit, setCreditLimit] = useState(false);
  const handleOpenRPoint = (newOpen: boolean) => {
    setOpenRPoint(newOpen);
  };
  const handleOpenCreditLimit = (newOpen: boolean) => {
    setCreditLimit(newOpen);
  };
  const dashboardData = [
    {
      text: "My Bookings",
      link: "https://b2b-dashboard.efficienttour.com/#/home/booking",
    },
    {
      text: "My Report",
      link: "https://b2b-dashboard.efficienttour.com/#/home/booking",
    },
    {
      text: "My Quotations",
      link: "https://b2b-dashboard.efficienttour.com/#/home/booking",
    },
    {
      text: "My Email Flyers",
      link: "https://b2b-dashboard.efficienttour.com/#/home/booking",
    },
  ];

  const menuItems = [
    { key: "1", label: "English" },
    { key: "2", label: "French" },
    { key: "3", label: "Spanish" },
  ];

  const profileMenu = [
    { key: "1", label: "My Profile", link: "https://example.com/item1" },
    { key: "2", label: "Sign Out", link: "https://example.com/item2" },
  ];

  const [isVisible, setIsVisible] = useState(false); // State to track visibility

  // Toggle visibility
  const toggleDiv = () => {
    setIsVisible((prev) => !prev);
  };

  useEffect(() => {
    // Set isVisible to false if screen is lg or larger
    if (screens.lg || screens.xl) {
      setIsVisible(true);
    } else {
      setIsVisible(true);
    }
  }, [screens]); // Re-run the effect whenever screens change

  return (
    <Header
      style={{
        display: "flex",
        alignItems: "center",
        paddingTop: "10px", // Add top padding
        paddingBottom: "10px", // Add bottom padding
        paddingLeft: "0px", // Add bottom padding
        paddingRight: "0px", // Add bottom padding
        height: "auto",
      }}
      className="light-header"
    >
      <div className="container">
        <Flex justify="space-between" align="center">
          <Flex justify="space-between" align="center" className="w-100">
            <div className="demo-logo">
              <Button type="link" href="/" className="px-0"> 
                <Image width={200} src={logo} preview={false} />{" "}
              </Button>
            </div>
            {(screens.xs || screens.sm || screens.md) && !screens.lg && (
              <Button onClick={toggleDiv}  variant="link" 
              type="link"
              color="default"  className="ml-auto" size="small">
                <MenuOutlined />
              </Button>
            )}
          </Flex>

          <Flex
            className={`mobileView ${isVisible ? "" : "mobileViewShow"}`}
            gap="small"
            justify="flex-end"
            align={
              (screens.xs || screens.sm || screens.md) && !screens.lg
                ? "stretch"
                : "center"
            }
            vertical={(screens.xs || screens.sm || screens.md) && !screens.lg}
          >
            <Button
              variant="link"
              type="link"
              color="default" 
              onClick={()=>setIsVisible(true)}
              className={`ml-auto mobileMenuButton w-40 ${screens.lg ? 'd-none' : 'd-flex'} }`}
               
            >
              <CloseOutlined />
            </Button>
            <div>
              <Dropdown
                overlay={helplineMenu}
                trigger={["hover"]}
                className="custom-dropdown mobileMenuButton"
              >
                <Button onClick={(e) => e.preventDefault()} type="link" >
                 <Flex align="center" gap={8}> <Image width={30} src={helpline} preview={false} />
                 
                 {(screens.lg
                ? ''
                : 'Helpline'
                 )}

                   </Flex>  

                 {(screens.lg
                ? ''
                : <CaretDownOutlined />
                 )}

                  
                </Button>
              </Dropdown>
            </div>

            {/* Register Here Button */}
            <Button
              shape="round"
              color="primary"
              variant="outlined"
              className="menu-button mobileMenuButton"
              type="link"
              href="#/register"
            >
              Register Here
            </Button>

            <Popover
              content={
                <Flex gap={20} vertical className="p-2">
                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Earned Points : </label>
                    <Input size="small" value={0} className="success" />
                  </Flex>

                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Redemeed Points : </label>
                    <Input size="small" value={0} className="info" />
                  </Flex>

                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Available Points : </label>
                    <Input size="small" value={0} className="warning" />
                  </Flex>
                </Flex>
              }
              title=""
              trigger="click"
              open={openRPoint}
              onOpenChange={handleOpenRPoint}
              overlayClassName="pouOver"
            >
              <Button type="link" className="mobileMenuButton">
                R Points <CaretDownOutlined />
              </Button>
            </Popover>

            <Popover
              content={
                <Flex gap={20} vertical className="p-2">
                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Credit Limit : </label>
                    <Text className="font-14">AED 0.01</Text>
                  </Flex>

                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Available Limit : </label>
                    <Text className="font-14">AED 0.01</Text>
                  </Flex>

                  <Flex className="rpoint" align="center" gap={15}>
                    <label htmlFor="">Credit Used : </label>
                    <Text className="font-14">AED 0.00</Text>
                  </Flex>
                  <Button type="primary" danger variant="link">
                    Topup
                  </Button>
                </Flex>
              }
              className="pouOver"
              title=""
              trigger="click"
              open={openCreditLimit}
              onOpenChange={handleOpenCreditLimit}
            >
              <Button type="link" className="mobileMenuButton">
                Credit Limit
                <CaretDownOutlined />
              </Button>
            </Popover>

            <Popover
              content={
                <Flex gap={20} vertical className="">
                  <List
                    bordered={false}
                    dataSource={dashboardData}
                    size="small"
                    className="dashboardList"
                    renderItem={(item) => (
                      <List.Item>
                        <Button type="text" href={item.link} target="_blank">
                          {item.text}
                        </Button>
                      </List.Item>
                    )}
                  />
                </Flex>
              }
              title=""
            >
              <Button type="link" className="mobileMenuButton">
                Dashboard
                <CaretDownOutlined />
              </Button>
            </Popover>

            {/* Supplier Register Button */}
            <Button
              shape="round"
              color="primary"
              type="link"
              className="menu-button mobileMenuButton"
            >
              Supplier Register
            </Button>

            {/* Language Dropdown */}
            <div style={{ order: screens.sm ? 2 : 0 }}>
              <Dropdown
                menu={{
                  items: menuItems, // Pass items as part of the menu prop
                }}
                trigger={["hover"]}
                className="custom-dropdown mobileMenuButton"
              >
                <Button type="link"
                  onClick={(e) => e.preventDefault()}
                >
                  <Flex align="center" wrap gap={8}> <Image width={30} src={language} preview={false} />{" "}
                  {false && <DownOutlined />}
                  
                  {(screens.lg
                ? ''
                : 'Select Language'
                 )}
                 </Flex> 
                  
                </Button>
              </Dropdown>
            </div>

            <div style={{ order: screens.sm ? 2 : 0 }}>
              <Dropdown
                menu={{
                  items: profileMenu, // Pass items as part of the menu prop
                }}
                trigger={["hover"]}
                className="mobileMenuButton"
              >
                <Button type="link">
                  AGT-09321
                  <CaretDownOutlined />
                </Button>
              </Dropdown>
            </div>
          </Flex>
        </Flex>
      </div>
    </Header>
  );
}

export default HeaderComponent;
